/**
 * Mock Data for Resume AI Demo
 * بيانات تجريبية شاملة لعرض إمكانيات التطبيق
 */

// بيانات ملف شخصي نموذجي لمهندس برمجيات أول
export const mockProfile = {
    personalInfo: {
        name: "محمد أحمد العلي",
        email: "mohammed.ali@example.com",
        phone: "+966 55 123 4567",
        location: "الرياض، المملكة العربية السعودية",
        linkedin: "linkedin.com/in/mohammedali",
        github: "github.com/mohammedali",
        website: "mohammedali.dev",
        summary: "مهندس برمجيات أول بخبرة تزيد عن 8 سنوات في بناء تطبيقات ويب قابلة للتوسع وقيادة فرق هندسية عالية الأداء. شغوف بالكود النظيف وتجربة المطور وإنشاء منتجات تحدث فرقاً."
    },
    certifications: [
        {
            id: 1,
            name: "AWS Solutions Architect - Professional",
            issuer: "Amazon Web Services",
            date: "2024-06",
            credentialId: "AWS-SAP-2024-12345",
            url: "https://aws.amazon.com/verification"
        },
        {
            id: 2,
            name: "Google Cloud Professional Cloud Architect",
            issuer: "Google Cloud",
            date: "2023-11",
            credentialId: "GCP-PCA-2023-67890",
            url: "https://cloud.google.com/certification"
        },
        {
            id: 3,
            name: "Certified Kubernetes Administrator (CKA)",
            issuer: "CNCF",
            date: "2023-08",
            credentialId: "CKA-2023-11111",
            url: "https://www.cncf.io/certification/cka"
        }
    ],
    experience: [
        {
            id: 1,
            title: "مهندس برمجيات أول",
            company: "شركة التقنية المتقدمة",
            location: "الرياض، السعودية",
            startDate: "2021-03",
            endDate: null,
            current: true,
            description: "قيادة تطوير بنية الخدمات المصغرة السحابية التي تخدم أكثر من 10 مليون مستخدم نشط يومياً",
            achievements: [
                "تصميم وتنفيذ خدمات مصغرة قائمة على الأحداث مما قلل زمن استجابة النظام بنسبة 60%",
                "قيادة الانتقال من البنية الأحادية إلى Kubernetes، مما حسّن تكرار النشر بنسبة 300%",
                "إرشاد فريق من 8 مهندسين وتأسيس معايير الترميز وأفضل الممارسات",
                "تقليل تكاليف البنية التحتية بمقدار 500 ألف دولار سنوياً من خلال التحسين واستراتيجيات التوسع التلقائي"
            ],
            technologies: ["React", "Node.js", "TypeScript", "AWS", "Kubernetes", "PostgreSQL", "Redis", "GraphQL"]
        },
        {
            id: 2,
            title: "مهندس برمجيات",
            company: "شركة تحليلات البيانات",
            location: "جدة، السعودية",
            startDate: "2018-06",
            endDate: "2021-02",
            current: false,
            description: "بناء خطوط معالجة البيانات في الوقت الفعلي ولوحات التحليلات",
            achievements: [
                "تطوير خط تحليلات في الوقت الفعلي يعالج أكثر من مليون حدث في الثانية",
                "إنشاء لوحات تحكم تفاعلية لتصور البيانات يستخدمها أكثر من 500 عميل مؤسسي",
                "تنفيذ كشف الشذوذ المدعوم بالتعلم الآلي مما قلل وقت الاستجابة للحوادث بنسبة 45%",
                "تحسين استعلامات قاعدة البيانات مما أدى إلى تحسين سرعة إنشاء التقارير بنسبة 80%"
            ],
            technologies: ["Python", "Apache Kafka", "Spark", "React", "D3.js", "PostgreSQL", "Docker"]
        },
        {
            id: 3,
            title: "مطور مبتدئ",
            company: "شركة الابتكار الرقمي",
            location: "الدمام، السعودية",
            startDate: "2016-01",
            endDate: "2018-05",
            current: false,
            description: "تطوير Full-stack لمنتجات SaaS في مراحلها المبكرة",
            achievements: [
                "بناء MVP ساعد في تأمين تمويل بذري بقيمة 2 مليون دولار",
                "تطوير واجهات برمجة RESTful تخدم تطبيقات الجوال والويب",
                "تنفيذ اختبارات آلية محققاً تغطية كود بنسبة 85%",
                "التعاون مع فريق التصميم لإنشاء واجهات مستخدم بديهية"
            ],
            technologies: ["JavaScript", "React", "Node.js", "MongoDB", "Express", "AWS"]
        }
    ],
    projects: [
        {
            id: 1,
            name: "منصة أتمتة البنية التحتية السحابية",
            description: "منصة مفتوحة المصدر لإدارة البنية التحتية السحابية بشكل آلي",
            url: "https://github.com/mohammedali/cloudscale",
            startDate: "2023-01",
            endDate: null,
            highlights: [
                "أكثر من 2,500 نجمة على GitHub و300+ تفريع",
                "تستخدمها أكثر من 50 شركة لأتمتة البنية التحتية",
                "عُرضت في معرض مجتمع AWS re:Invent"
            ],
            technologies: ["Go", "Terraform", "AWS CDK", "React", "GraphQL"]
        },
        {
            id: 2,
            name: "لوحة إنتاجية الفرق الهندسية",
            description: "لوحة تحكم في الوقت الفعلي لتتبع مقاييس الفريق الهندسي ومؤشرات DORA",
            url: "https://devmetrics.io",
            startDate: "2022-06",
            endDate: "2023-06",
            highlights: [
                "متكاملة مع GitHub وJira وخطوط CI/CD",
                "توفر رؤى قابلة للتنفيذ لقادة الهندسة",
                "قللت وقت النشر بنسبة 40% للمستخدمين الأوائل"
            ],
            technologies: ["TypeScript", "Next.js", "PostgreSQL", "Chart.js", "Docker"]
        },
        {
            id: 3,
            name: "منشئ السيرة الذاتية بالذكاء الاصطناعي",
            description: "أداة تحسين السيرة الذاتية المدعومة بالتعلم الآلي مع فحص التوافق مع ATS",
            url: "https://github.com/mohammedali/ai-resume",
            startDate: "2024-01",
            endDate: null,
            highlights: [
                "يستخدم GPT-4 لاقتراحات المحتوى الذكية",
                "تحسين نقاط ATS مع تغذية راجعة فورية",
                "يدعم قوالب وتنسيقات متعددة للسيرة الذاتية"
            ],
            technologies: ["Python", "FastAPI", "React", "OpenAI API", "PostgreSQL"]
        }
    ],
    education: [
        {
            id: 1,
            degree: "ماجستير علوم الحاسب",
            institution: "جامعة الملك سعود",
            location: "الرياض، السعودية",
            startDate: "2014",
            endDate: "2016",
            gpa: "3.9",
            honors: "قائمة الشرف، زمالة البحث العلمي",
            coursework: ["الأنظمة الموزعة", "التعلم الآلي", "الخوارزميات المتقدمة", "الحوسبة السحابية"]
        },
        {
            id: 2,
            degree: "بكالوريوس هندسة الحاسب",
            institution: "جامعة الملك فهد للبترول والمعادن",
            location: "الظهران، السعودية",
            startDate: "2010",
            endDate: "2014",
            gpa: "3.7",
            honors: "بامتياز مع مرتبة الشرف، فائز بمسابقة ACM للبرمجة",
            coursework: ["هياكل البيانات", "أنظمة التشغيل", "هندسة الحاسب", "هندسة البرمجيات"]
        }
    ],
    skills: [
        { id: 1, name: "JavaScript/TypeScript", category: "لغات البرمجة", proficiency: "خبير" },
        { id: 2, name: "Python", category: "لغات البرمجة", proficiency: "خبير" },
        { id: 3, name: "Go", category: "لغات البرمجة", proficiency: "متقدم" },
        { id: 4, name: "React/Next.js", category: "الواجهة الأمامية", proficiency: "خبير" },
        { id: 5, name: "Node.js", category: "الخادم", proficiency: "خبير" },
        { id: 6, name: "AWS", category: "السحابة", proficiency: "خبير" },
        { id: 7, name: "Kubernetes", category: "DevOps", proficiency: "متقدم" },
        { id: 8, name: "PostgreSQL", category: "قواعد البيانات", proficiency: "خبير" },
        { id: 9, name: "GraphQL", category: "واجهات البرمجة", proficiency: "متقدم" },
        { id: 10, name: "Docker", category: "DevOps", proficiency: "خبير" },
        { id: 11, name: "Terraform", category: "البنية التحتية", proficiency: "متقدم" },
        { id: 12, name: "CI/CD", category: "DevOps", proficiency: "خبير" }
    ],
    awards: [
        {
            id: 1,
            name: "جائزة التميز الهندسي",
            issuer: "شركة التقنية المتقدمة",
            date: "2023",
            description: "تقديراً للقيادة التقنية المتميزة والابتكار"
        },
        {
            id: 2,
            name: "أفضل محاضرة تقنية",
            issuer: "KubeCon الشرق الأوسط",
            date: "2022",
            description: "قدمت 'توسيع Kubernetes في الإنتاج: دروس من 10 مليون مستخدم'"
        },
        {
            id: 3,
            name: "جائزة المساهم في المصادر المفتوحة",
            issuer: "GitHub",
            date: "2021",
            description: "ضمن أفضل 100 مساهم في فئة البنية التحتية السحابية"
        }
    ],
    languages: [
        { id: 1, name: "العربية", proficiency: "اللغة الأم" },
        { id: 2, name: "الإنجليزية", proficiency: "طلاقة" },
        { id: 3, name: "الفرنسية", proficiency: "محادثة" }
    ],
    industryExperience: [
        { id: 1, industry: "التقنية المالية", years: 3, description: "معالجة المدفوعات وتحليلات البيانات المالية" },
        { id: 2, industry: "البرمجيات كخدمة", years: 5, description: "منصات B2B وحلول المؤسسات" },
        { id: 3, industry: "التجارة الإلكترونية", years: 2, description: "منصات البيع بالتجزئة عالية الحركة وأنظمة المخزون" }
    ]
};

// أوصاف وظيفية نموذجية للعرض التجريبي
export const sampleJobDescriptions = [
    {
        id: 1,
        title: "مهندس برمجيات رئيسي",
        company: "أرامكو الرقمية",
        description: `عن الدور:
نبحث عن مهندس برمجيات رئيسي للانضمام إلى فريق البنية التحتية. ستكون مسؤولاً عن تصميم وتنفيذ أنظمة موزعة قابلة للتوسع تدعم منتجاتنا التي تخدم ملايين المستخدمين.

المتطلبات:
- خبرة 8+ سنوات في هندسة البرمجيات
- معرفة خبيرة بالأنظمة الموزعة والخدمات المصغرة
- خبرة مع منصات السحابة (AWS أو GCP أو Azure)
- إتقان قوي في Python أو Java أو Go
- خبرة مع Kubernetes وتنسيق الحاويات
- سجل حافل في قيادة المشاريع التقنية وإرشاد المهندسين
- ماجستير/دكتوراه في علوم الحاسب أو مجال ذي صلة (مفضل)

مهارات إضافية مرغوبة:
- خبرة في بنية التعلم الآلي
- مساهمات في المصادر المفتوحة
- خبرة في الإلقاء والعروض التقديمية

ما نقدمه:
- راتب تنافسي وحوافز
- تأمين صحي شامل
- ترتيبات عمل مرنة
- ميزانية للتطوير المهني`
    },
    {
        id: 2,
        title: "مطور Full Stack أول",
        company: "شركة سلوشنز",
        description: `عن الشركة:
سلوشنز هي شركة تقنية تبني البنية التحتية الرقمية للأعمال. نساعد آلاف الشركات على قبول المدفوعات وإدارة عملياتها.

الدور:
انضم إلى فريق تجربة المطور لبناء أدوات تجعل من السهل للمطورين التكامل مع واجهات برمجة التطبيقات الخاصة بنا.

المتطلبات:
- خبرة 5+ سنوات في تطوير Full-stack
- خبرة قوية في React وTypeScript وNode.js
- خبرة في بناء وصيانة واجهات برمجة على نطاق واسع
- فهم ممتاز لأفضل ممارسات أمان الويب
- خبرة مع PostgreSQL أو قواعد بيانات مماثلة
- مهارات تواصل وتوثيق قوية

نقاط إضافية:
- خبرة مع أنظمة الدفع
- مساهمات في أدوات المطورين أو SDKs
- خبرة مع GraphQL

المزايا:
- ثقافة العمل عن بُعد
- مشاركة في الأسهم
- بدل التعلم والتطوير
- برامج الصحة والعافية`
    },
    {
        id: 3,
        title: "مدير هندسة - المنصة",
        company: "شركة نيوم التقنية",
        description: `عن الفريق:
يبني فريق المنصة في نيوم التقنية البنية التحتية الأساسية والأدوات التي تمكّن مؤسستنا الهندسية من التحرك بسرعة مع الحفاظ على الموثوقية.

ماذا ستفعل:
- قيادة فريق من 6-10 مهندسين يبنون بنية المنصة التحتية
- تحديد الاستراتيجية التقنية وخارطة الطريق لخدمات المنصة
- الشراكة مع المنتج والتصميم لتقديم تجربة مطور استثنائية
- دفع التميز التشغيلي وتحسينات الموثوقية

المتطلبات:
- خبرة 7+ سنوات في هندسة البرمجيات
- خبرة 2+ سنوات في إدارة الهندسة
- خبرة في بناء منصات المطورين أو البنية التحتية
- خلفية تقنية قوية في الأنظمة الموزعة
- مهارات تواصل وإدارة أصحاب المصلحة ممتازة
- خبرة مع منهجيات Agile

ما نقدره:
- عقلية القيادة الخادمة
- اتخاذ القرارات المبني على البيانات
- ثقافة التحسين المستمر

التعويضات:
- راتب أساسي تنافسي: 50,000 - 70,000 ريال شهرياً
- مكافأة سنوية وأسهم
- حزمة مزايا شاملة`
    }
];

// مخرجات السيرة الذاتية المُنشأة النموذجية
export const mockGeneratedResume = {
    markdown: `# محمد أحمد العلي
الرياض، السعودية | mohammed.ali@example.com | +966 55 123 4567
[LinkedIn](linkedin.com/in/mohammedali) | [GitHub](github.com/mohammedali) | [الموقع](mohammedali.dev)

## الملخص المهني
مهندس برمجيات أول موجه بالنتائج مع خبرة تزيد عن 8 سنوات في تصميم وتنفيذ أنظمة موزعة قابلة للتوسع. سجل حافل في قيادة المبادرات التقنية التي حسّنت أداء النظام بنسبة 60% وخفضت تكاليف البنية التحتية بمقدار 500 ألف دولار سنوياً. خبير في البنى السحابية والخدمات المصغرة وتحسين تجربة المطور.

## المهارات التقنية
**اللغات:** JavaScript، TypeScript، Python، Go
**الواجهة الأمامية:** React، Next.js، GraphQL، D3.js
**الخادم:** Node.js، Express، FastAPI
**السحابة و DevOps:** AWS (Solutions Architect Professional)، GCP، Kubernetes، Docker، Terraform
**قواعد البيانات:** PostgreSQL، Redis، MongoDB
**الأدوات:** Git، CI/CD، Kafka، Spark

## الخبرة المهنية

### مهندس برمجيات أول | شركة التقنية المتقدمة
*الرياض، السعودية | مارس 2021 - الحاضر*
- تصميم بنية خدمات مصغرة قائمة على الأحداث تخدم أكثر من 10 مليون مستخدم نشط يومياً، مما قلل زمن استجابة النظام بنسبة 60%
- قيادة الانتقال من البنية الأحادية إلى البنية القائمة على Kubernetes، مما حسّن تكرار النشر بنسبة 300%
- إرشاد فريق من 8 مهندسين وتأسيس معايير ترميز قللت وقت مراجعة الكود بنسبة 40%
- تنفيذ استراتيجيات التوسع التلقائي مما خفض تكاليف البنية التحتية السنوية بمقدار 500 ألف دولار

### مهندس برمجيات | شركة تحليلات البيانات
*جدة، السعودية | يونيو 2018 - فبراير 2021*
- تطوير خط تحليلات في الوقت الفعلي يعالج أكثر من مليون حدث في الثانية باستخدام Kafka و Spark
- إنشاء لوحات تحكم تفاعلية يستخدمها أكثر من 500 عميل مؤسسي، مما حسّن تفاعل المستخدمين بنسبة 45%
- تنفيذ كشف الشذوذ المدعوم بالتعلم الآلي، مما قلل وقت الاستجابة للحوادث بنسبة 45%

## المشاريع الرئيسية

### منصة أتمتة البنية التحتية السحابية
- منصة مفتوحة المصدر مع أكثر من 2,500 نجمة على GitHub، تستخدمها أكثر من 50 شركة
- عُرضت في معرض مجتمع AWS re:Invent
- بُنيت باستخدام Go، Terraform، AWS CDK، React، و GraphQL

### لوحة إنتاجية الفرق الهندسية
- تتبع مقاييس DORA في الوقت الفعلي متكاملة مع GitHub وJira وCI/CD
- قللت وقت النشر بنسبة 40% للمنظمات المستخدمة الأولى

## التعليم

**ماجستير علوم الحاسب** | جامعة الملك سعود | 2016
- معدل: 3.9 | قائمة الشرف، زمالة البحث العلمي

**بكالوريوس هندسة الحاسب** | جامعة الملك فهد للبترول والمعادن | 2014
- معدل: 3.7 | بامتياز مع مرتبة الشرف، فائز بمسابقة ACM للبرمجة

## الشهادات
- AWS Solutions Architect - Professional (2024)
- Google Cloud Professional Cloud Architect (2023)
- Certified Kubernetes Administrator (2023)

## الجوائز والتقدير
- جائزة التميز الهندسي، شركة التقنية المتقدمة (2023)
- أفضل محاضرة تقنية، KubeCon الشرق الأوسط (2022)
- جائزة المساهم في المصادر المفتوحة من GitHub (2021)`,
    matchScore: 92,
    aiMatchAnalysis: {
        strengths: [
            "خبرة واسعة في الأنظمة الموزعة تتوافق مع متطلبات الوظيفة",
            "خبرة سحابية قوية مع شهادات ذات صلة (AWS، GCP)",
            "خبرة قيادية مثبتة في إرشاد الفرق الهندسية",
            "سجل حافل بتأثير قابل للقياس على أداء النظام"
        ],
        matched_requirements: [
            "خبرة 8+ سنوات في هندسة البرمجيات",
            "معرفة خبيرة بالأنظمة الموزعة والخدمات المصغرة",
            "خبرة مع منصات AWS وGCP السحابية",
            "خبرة Kubernetes مع شهادة CKA",
            "سجل حافل في قيادة المشاريع التقنية",
            "خبرة في إرشاد المهندسين"
        ],
        gaps: [
            "يمكن إبراز المزيد من خبرة بنية التعلم الآلي",
            "فكر في إضافة مشاريع محددة بـ Java إن وجدت"
        ],
        recommendations: [
            "أبرز خبرة الإلقاء في KubeCon لمتطلب العروض التقديمية",
            "أبرز مساهمات المصادر المفتوحة بشكل أكثر وضوحاً",
            "فكر في إضافة إنجازات متعلقة بالتعلم الآلي إن توفرت"
        ]
    },
    downloadUrl: "/demo/download/resume.docx",
    pdfPreviewUrl: "/demo/preview/resume.pdf"
};

// سجل السير الذاتية النموذجي
export const mockResumeHistory = [
    {
        id: 1,
        job_title: "مهندس برمجيات رئيسي في أرامكو الرقمية",
        template: "احترافي",
        match_score: 92,
        created_at: "2026-01-15T10:30:00Z",
        job_description: "وظيفة مهندس برمجيات رئيسي متخصص في الأنظمة الموزعة..."
    },
    {
        id: 2,
        job_title: "مطور Full Stack أول في سلوشنز",
        template: "عصري",
        match_score: 88,
        created_at: "2026-01-14T14:45:00Z",
        job_description: "مطور Full Stack أول لفريق تجربة المطور..."
    },
    {
        id: 3,
        job_title: "مدير هندسة في نيوم التقنية",
        template: "احترافي",
        match_score: 85,
        created_at: "2026-01-12T09:15:00Z",
        job_description: "مدير هندسة - دور قيادي لفريق المنصة..."
    },
    {
        id: 4,
        job_title: "مهندس رئيسي في STC",
        template: "إبداعي",
        match_score: 90,
        created_at: "2026-01-10T16:20:00Z",
        job_description: "مهندس رئيسي للبنية التحتية السحابية..."
    },
    {
        id: 5,
        job_title: "قائد تقني في زين",
        template: "عصري",
        match_score: 87,
        created_at: "2026-01-08T11:00:00Z",
        job_description: "قائد تقني لخدمات منصة الاتصالات..."
    }
];

// إحصائيات السجل النموذجية
export const mockHistoryStats = {
    total_resumes: 12,
    avg_match_score: 88.5,
    resumes_this_month: 5,
    top_match_score: 95
};

// معاينة الاختيار النموذجية
export const mockSelectionPreview = {
    experience: [
        { title: "مهندس برمجيات أول", company: "شركة التقنية المتقدمة" },
        { title: "مهندس برمجيات", company: "شركة تحليلات البيانات" }
    ],
    projects: [
        { name: "منصة أتمتة البنية التحتية السحابية" },
        { name: "لوحة إنتاجية الفرق الهندسية" }
    ],
    skills: [
        { name: "JavaScript/TypeScript" },
        { name: "Python" },
        { name: "AWS" },
        { name: "Kubernetes" },
        { name: "React/Next.js" }
    ],
    certifications: [
        { name: "AWS Solutions Architect - Professional" },
        { name: "Certified Kubernetes Administrator (CKA)" }
    ]
};

// القوالب المتاحة
export const mockTemplates = [
    { name: "professional", label: "احترافي", description: "تصميم نظيف وتقليدي مثالي للوظائف المؤسسية" },
    { name: "modern", label: "عصري", description: "تصميم معاصر مع مساحات بيضاء متوازنة" },
    { name: "creative", label: "إبداعي", description: "تميّز بتنسيق وأسلوب فريد" }
];
